import { useFavorites } from '@hooks';
import { News, useGetNewsMutation } from '@services';
import { useEffect, useState } from 'react';

export const useHomePageVM = () => {
    const [news, setNews] = useState<Array<News>>([]);
    const [isLoadingNews, setIsLoadingNews] = useState(true);

    const { isLoadingFavorites, favorites } = useFavorites();
    const [getNews, { isLoading, data: newsData }] = useGetNewsMutation();

    useEffect(() => {
        getNews();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (newsData) {
            setNews(newsData);
            setIsLoadingNews(false);
        }
    }, [isLoading, newsData]);

    return { isLoadingNews, isLoadingFavorites, latestNews: news.length > 0 ? news[0] : null, favorites };
};
